import { IAddressDto } from "@models/address-dto";
import { MetadataPutEnum } from "@models/enums/metadata-put-enum";
import { IAttachmentDto } from "@models/portal/users/dtos/attachment-dto";
import { IContactDto } from "@models/portal/users/dtos/contact-dto";
import { IDocumentDto } from "@models/portal/users/dtos/document-dto";
import { IUserDto } from "@models/portal/users/dtos/user-dto";
import { ContaBancariaDto } from "@models/portal/users/dtos/user-relationship-dto";
import { IUserResponsibleDto } from "@models/portal/users/dtos/user-responsible-dto";
import { AddressForm } from "@models/portal/users/forms/address-form";
import { AttachmentForm } from "@models/portal/users/forms/attachment-form";
import { ContactForm } from "@models/portal/users/forms/contact-form";
import { DocumentForm } from "@models/portal/users/forms/document-form";
import { UserForm } from "@models/portal/users/forms/user-form";
import { ContaBancariaForm } from "@models/portal/users/forms/user-relationship-form";
import { UserResponsibleForm } from "@models/portal/users/forms/user-responsible-form";

export function verifyBasicDataChanges(currentFormState: UserForm, storedState: IUserDto) {
  const changedFields: Partial<UserForm> = {};

  const excludedFields = ['entNrId', 'entTxMetadado', 'usuListResponsavel'];
  const fieldsToCheck = Object.keys(currentFormState).filter(field => !excludedFields.includes(field)) as (keyof UserForm)[];

  fieldsToCheck.forEach(field => {
    if (currentFormState[field as keyof UserForm] !== storedState[field as keyof IUserDto]) {
      const currentFormValue = currentFormState[field];
      const storedValue = storedState[field as keyof IUserDto];

      if (currentFormValue !== storedValue) {
        changedFields[field] = currentFormValue as any;
      }
    }
  });

  if (Object.keys(changedFields).length > 0) {
    currentFormState.entTxMetadado = MetadataPutEnum.ALTERADO;
  }

  return changedFields;
}

export function verifyResponsibleChanges(currentFormState: UserResponsibleForm[], storedState: IUserResponsibleDto[]) {

  currentFormState.forEach(currentResponsibleForm => {
    const storedResponsible = storedState.find(responsible => responsible.ureNrId === currentResponsibleForm.entNrId);

    if (storedResponsible) {
      let modified: boolean = false;

      if (currentResponsibleForm.ureTxParentesco !== storedResponsible.ureTxParentesco) modified = true;

      if (modified) {
        currentResponsibleForm.entTxMetadado = MetadataPutEnum.ALTERADO;
      }
    }
  });

}

export function verifyAddressChanges(currentFormState: AddressForm, storedState: IAddressDto[]) {
  const changedFields: Partial<AddressForm> = {};

  const excludedFields = ['entNrId', 'entTxMetadado', 'usuListResponsavel'];
  const fieldsToCheck = Object.keys(currentFormState).filter(field => !excludedFields.includes(field)) as (keyof AddressForm)[];

  fieldsToCheck.forEach(field => {
    if (currentFormState[field as keyof AddressForm] !== storedState[0][field as keyof IAddressDto]) {
      const currentFormValue = currentFormState[field];
      const storedValue = storedState[0][field as keyof IAddressDto];

      if (currentFormValue !== storedValue) {
        changedFields[field] = currentFormValue as any;
      }
    }
  });

  if (Object.keys(changedFields).length > 0) {
    currentFormState.entTxMetadado = MetadataPutEnum.ALTERADO;
  }

  return changedFields;
}

export function verifyContactsChanges(currentFormState: ContactForm[], storedState: IContactDto[]) {
  const changedContacts: Partial<ContactForm>[] = [];

  currentFormState.forEach(currentContactForm => {
    const storedContact = storedState.find(contact => contact.conNrId === currentContactForm.entNrId);

    if (storedContact) {
      const changedFields: Partial<ContactForm> = {};

      const excludedFields = ['entNrId', 'entTxMetadado'];
      const fieldsToCheck = Object.keys(currentContactForm).filter(field => !excludedFields.includes(field)) as (keyof ContactForm)[];

      fieldsToCheck.forEach(field => {
        const currentFormValue = currentContactForm[field];
        const storedValue = storedContact[field as keyof IContactDto];

        if (currentFormValue !== storedValue) {
          changedFields[field] = currentFormValue as any;
        }
      });

      if (Object.keys(changedFields).length > 0) {
        currentContactForm.entTxMetadado = MetadataPutEnum.ALTERADO;

        changedFields.entNrId = currentContactForm.entNrId;
        changedContacts.push(changedFields);
      }
    }
  });

  return changedContacts;
}

export function verifyDocumentsChanges(currentFormState: DocumentForm[], storedState: IDocumentDto[]) {
  const changedDocuments: Partial<DocumentForm>[] = [];

  currentFormState.forEach(currentDocumentForm => {
    const storedDocument = storedState.find(document => document.docNrId === currentDocumentForm.entNrId);

    if (storedDocument) {
      const changedFields: Partial<DocumentForm> = {};

      const excludedFields = ['entNrId', 'entTxMetadado', 'label', 'mask', 'placeholder'];
      const fieldsToCheck = Object.keys(currentDocumentForm).filter(field => !excludedFields.includes(field)) as (keyof DocumentForm)[];

      fieldsToCheck.forEach(field => {
        const currentFormValue = currentDocumentForm[field];
        const storedValue = storedDocument[field as keyof IDocumentDto];

        if (currentFormValue !== storedValue) {
          changedFields[field] = currentFormValue as any;
        }
      });

      if (Object.keys(changedFields).length > 0) {
        currentDocumentForm.entTxMetadado = MetadataPutEnum.ALTERADO;

        changedFields.entNrId = currentDocumentForm.entNrId;
        changedDocuments.push(changedFields);
      }
    }
  });

  return changedDocuments;
}

export function verifyAttachmentChanges(currentFormState: AttachmentForm[], storedState: IAttachmentDto[]) {
  const changedAttachments: Partial<AttachmentForm>[] = [];

  currentFormState.forEach(currentAttachmentForm => {
    const storedAttachment = storedState.find(attachment => attachment.aneNrId === currentAttachmentForm.entNrId);

    if (storedAttachment) {
      const changedFields: Partial<AttachmentForm> = {};

      const excludedFields = ['entNrId', 'entTxMetadado'];
      const fieldsToCheck = Object.keys(currentAttachmentForm).filter(field => !excludedFields.includes(field)) as (keyof AttachmentForm)[];

      fieldsToCheck.forEach(field => {
        const currentFormValue = currentAttachmentForm[field];
        const storedValue = storedAttachment[field as keyof IAttachmentDto];

        if (currentFormValue !== storedValue) {
          changedFields[field] = currentFormValue as any;
        }
      });

      if (Object.keys(changedFields).length > 0) {
        currentAttachmentForm.entTxMetadado = MetadataPutEnum.ALTERADO;

        changedFields.entNrId = currentAttachmentForm.entNrId;
        changedAttachments.push(changedFields);
      }
    }
  });

  return changedAttachments;
}

export function verifyContaBancariaChanges(currentFormState: ContaBancariaForm, storedState: ContaBancariaDto | null) {

  if (!storedState || Object.keys(storedState).length === 0) {
    currentFormState.entTxMetadado = MetadataPutEnum.CRIADO;
    return;
  }

  let modified = false;
  let agencia, banco, numero, contaTipo = false;

  currentFormState.entNrId = storedState?.cobNrId;

  agencia = storedState?.ageNrId !== currentFormState.ageNrId;
  banco = storedState?.banNrId !== currentFormState.banNrId;
  numero = storedState?.cobTxNumeroConta !== currentFormState.cobTxNumeroConta;
  contaTipo = storedState?.cobTxTipoConta !== currentFormState.cobTxTipoConta;

  modified = agencia || banco || numero || contaTipo;

  if (modified) {
    currentFormState.entTxMetadado = MetadataPutEnum.ALTERADO;
  }else{
    currentFormState.entTxMetadado = MetadataPutEnum.INALTERADO;
  }

}
